import { useState, useEffect } from "react";
import styled from "styled-components";
import Link from "next/link";
import { LocatedJob } from "~/types/jobs";
import Title from "~/shared/Title";
import { getAddressFormatted } from "~/utils/address";

const Container = styled.div`
    & * {
        text-decoration: none;
    }

    .cover {
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.7);
        top: 0;
        left: 0;
        display: none;

        span {
            color: #fff;
            font-weight: bold;
            text-align: center;
            font-size: 1.75rem;
            display: inline-block;
            text-align: center;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 100%;
        }
    }

    figure {
        width: 100%;
        height: 200px;
        overflow: hidden;
        border-radius: 15px;
        position: relative;

        img {
            width: 100%;
        }
    }

    &:hover .cover {
        display: block;
    }
`;

const getCover = (job: LocatedJob) => {
    const possibleCovers = job?.files?.filter(file => file.type === "jpg" && file.target === "cliente");
    if (!possibleCovers?.length) {
        return "/images/gallery-placeholder-small.jpg";
    }

    const cover = possibleCovers.find(file => file.cover);
    if (!cover) {
        return possibleCovers[0]?.thumb || "/images/gallery-placeholder-big.jpg";
    }

    return cover.thumb || "/images/gallery-placeholder-big.jpg";
};

type JobSmallWithThumbsProps = {
    job: LocatedJob;
};

const JobSmallWithThumbs = ({ job }: JobSmallWithThumbsProps) => {
    const [cover, setCover] = useState("/images/gallery-placeholder-big.jpg");

    useEffect(() => {
        setCover(getCover(job));
    }, [job.id]);

    return (
        <Container>
            <Link href={`/gallery/${job.id}`}>
                <a>
                    <figure>
                        <div className="cover">
                            <span>
                                Visualizar todos os detalhes do job
                            </span>
                        </div>
                        <img src={cover} />
                    </figure>

                    <Title level="3">ID #{job.id}</Title>

                    <p>{getAddressFormatted({ addressParts: {
                        address: job?.address?.street,
                        number: job?.address?.number,
                        complement: job?.address?.complement,
                        neighborhood: job?.address?.complement,
                        cityName: job?.address?.city?.name,
                        stateAbbr: job?.address?.state?.uf,
                        zipCode: job?.address?.zipCode
                    } })}</p>
                </a>
            </Link>
        </Container>
    );
};

export default JobSmallWithThumbs;
